import React, { PropTypes } from 'react';

export default class RecipientsHeader extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    selectedCount: PropTypes.number.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    onUnselectAll: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(evt) {
    const value = evt.target.value;
    this.props.onChange(value);
  }

  render() {
    const { selectedCount, onSelectAll, onUnselectAll } = this.props;
    return (
      <div className="ui segment">
        <div className="header">
          Destinataires
          <em>{selectedCount} sélectionné(s)</em>
          <span className="action">
            <div className="ui input">
              <input
                type="text"
                placeholder="Recherche..."
                onChange={this.onChange}
              />
            </div>
            <div className="ui buttons">
              <button onClick={onUnselectAll} className="ui button">
                Aucun
              </button>
              <div className="or" data-text="ou" />
              <button onClick={onSelectAll} className="ui button">
                Tous
              </button>
            </div>
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/messaging/components/RecipientsHeader.js